const { createContext } = require("react");

export const ProductContext = createContext({
    productData: undefined,
    setProductData: () => {},
    productLoading: false,
    setProductLoading: () => {},
    productError: false,
    setProductError: () => {}
});
